import SHA256 from "crypto-js/sha256";
import { getUserEnv } from "./getUserEnv";
import {
  trackClarityEvent,
  identifyClarityUser,
  setClarityTags,
} from "./clarityTracking";
import {
  DEFAULT_LOCALE,
  getBaseLang,
  getCurrency,
  getLocaleFromPath,
} from "../../config/locales";

export const LoginSignUpEvent = ({ user, is_new, is_google, locale }) => {
  const activeLocale =
    locale ?? getLocaleFromPath(window.location.pathname) ?? DEFAULT_LOCALE;

  const email = user?.email || "";
  const hashedEmail = email
    ? SHA256(email.trim().toLowerCase()).toString()
    : null;

  // GTM tracking
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: is_new ? "signup_event" : "login_event",
    user_env: getUserEnv(),
    user_language: getBaseLang(activeLocale),
    currency: getCurrency(activeLocale),
    ...(hashedEmail && { user_email_hash: hashedEmail }),
    timestamp: new Date().toISOString(),
    login_mode: is_google ? "Google" : "Normal",
  });

  // Clarity tracking
  if (user?.id) {
    identifyClarityUser(user.id.toString());
  }
  setClarityTags(user, activeLocale);
  trackClarityEvent(is_new ? "signup" : "login", {
    login_mode: is_google ? "Google" : "Normal",
  });
};
